//行业应用
import React from "react";
import {Col, Row, Icon} from "antd";
import MyCard from './Card';
import SlidersArrows from "../Sliders/SlidersArrows";
import SlidersDots from "../Sliders/SlidersDots";
import {Link} from "react-router-dom";
import {getChildrenToRender} from "../utils";

import Education from "../img/Education.png";
import Hospital from "../img/Hospital.png";
import Industry from "../img/Industry.png";
import traffic from "../img/traffic.png";
import consumption from "../img/consumption.png";
import government from "../img/government.png";

export default class IndSolutions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            indSolutionList: [],
            startIndex: 0,
            autoPlayWise: true
        }
    }
    componentWillMount() {
        this.getIndSolutionList();
    }
    componentDidMount() {
        this.autoPlay();
    }

    getIndSolutionList = () => {
        const { startIndex } = this.state;
        const indSolutionList = [{
            linkUrl: './industrySolutions',
            imageUrl: Hospital,
            title: '医疗领域',
            content: '通过智能高清图像增强，快速智能修图呈现影楼级品质，提高影楼数码师工作效率。'
            }, {
            linkUrl: './industrySolutions',
            imageUrl: Education,
            title: '教育领域',
            content: '公交轨道TB级客流数据分析预测，实现快速精准分析、辅助优化发车班次、城市级出行需求精准分析。'
        }, {
            linkUrl: './industrySolutions',
            imageUrl: traffic,
            title: '交通领域',
            content: '货运物流各方主体（货主、货车司机、物流企业）的核心需求在平台上得以满足，从而建立一个货运物流生态圈。'
        }, {
            linkUrl: './industrySolutions',
            imageUrl: consumption,
            title: '消费服务',
            content: '通过智能高清图像增强，快速智能修图呈现影楼级品质，提高影楼数码师工作效率。'
        }, {
            linkUrl: './industrySolutions',
            imageUrl: government,
            title: '政府服务',
            content: '货运物流各方主体（货主、货车司机、物流企业）的核心需求在平台上得以满足，从而建立一个货运物流生态圈。'
        }];
        const currentIndSolutionList = [indSolutionList[startIndex], indSolutionList[startIndex + 1], indSolutionList[startIndex + 2]];
        this.setState({ indSolutionList, currentIndSolutionList });
    };
    // 下一个客户案例
    nextCus = () => {
        const { startIndex, indSolutionList } = this.state;
        if(startIndex === (indSolutionList.length - 3)) {
            this.setState({startIndex: (startIndex-2)})
            // return false;
        }else {
            let currentIndex = startIndex + 1;
            this.setState({
                startIndex: currentIndex
            });
        }
    };
    // 上一个客户案例
    previousCus = () => {
        const { startIndex, indSolutionList } = this.state;
        if(startIndex === 0) {
            this.setState({startIndex: (startIndex+2)})
            // return false;
        }else {
            let currentIndex = startIndex - 1;
            this.setState({
                startIndex: currentIndex
            });
        }
    };
    //自动播放
    autoPlay = () =>{
        this.timer = setInterval(() => {
            const {startIndex, autoPlayWise} = this.state;
            if (startIndex === 0) {
                this.setState({ autoPlayWise: true }, this.nextCus);
            }
            else if(startIndex === 1) {
                if(autoPlayWise) {
                    this.nextCus();
                } else {
                    this.previousCus();
                }
            }
            else if (startIndex === 2) {
                this.setState({ autoPlayWise: false }, this.previousCus);
            }
        },3000)
    };
    // 停止播放
    stopPlay = () => {
        clearInterval(this.timer)
    };
    // turn
    turn = (index) => {
        this.setState({ startIndex: index });
    };

    selectTab = () => {
        sessionStorage.setItem("activeTab","行业应用")
    };

    render() {
        const { indSolutionList, startIndex } = this.state;
        const indSolutionHtml = indSolutionList.map((item, index) => (
            <MyCard
              linkUrl={item.linkUrl}
                imageUrl={item.imageUrl}
                title={item.title}
                content={item.content}
                key={index}
            />
        ));
        return(
            <Row type="flex" justify="center" style={{backgroundColor:'#F2F6F9'}}>
                <Row onMouseOver={this.stopPlay} onMouseOut={this.autoPlay} style={{ padding: '64px 0',width:1200}}>
                    <Row type="flex" justify="center" style={{ marginBottom: 48 }}>
                        <div style={{fontSize:16}}>
                            <Link to="/customerCase" onClick={() => this.selectTab()} style={{color:'rgba( 0, 0, 0, 0.85)'}}>
                                <div style={{fontSize:32,textAlign:'center'}} className="home_title_kehuanli">行业应用</div>
                            </Link>
                        </div>
                    </Row>
                    <Row
                        type="flex"
                        justify="center"
                    >
                        <Row type="flex" align="middle" justify="end" style={{ height: 380, width: 50 }}>
                            <Icon type='left'  style={{fontSize: 40, color:startIndex===0?"rgba(16, 182, 255, 0.5)":"rgba(16, 182, 255, 1)"}} onClick={this.previousCus} />
                        </Row>
                        <Row type="flex" justify="center">
                            <div style={{ width: 1098, overflow: 'hidden' }}>
                                <Row type="flex" style={{ position: 'relative', right: 366 * startIndex, width: 1830, transition: 'all 1s' }}>
                                    {indSolutionHtml}
                                </Row>
                            </div>
                        </Row>
                        <Row type="flex" align="middle" style={{ height: 380, width: 50 }}>
                            <Icon type='right' style={{fontSize: 40, color:startIndex===2?"rgba(16, 182, 255, 0.5)":"rgba(16, 182, 255, 1)"}} onClick={this.nextCus}/>
                        </Row>
                    </Row>
                    <Row>
                        <SlidersDots
                            images={[1,2,3]}
                            turn={this.turn}
                            index={startIndex}
                            type="customer"
                            // style={{bottom:50}}
                        />
                    </Row>
                </Row>
            </Row>
        )
    }
}